import loadable from '@loadable/component';

const AssetLibrary = loadable(async () => import('./components/library/index.js'));
const ContentNav = loadable(async () => import('../common/components/nav/content-nav/index.js'));

export default {
  '/assets': {
    components: { main: AssetLibrary, nav: ContentNav }
  }
};
